import { render, staticRenderFns } from "./FolioGraph.vue?vue&type=template&id=36a7ea4e&scoped=true&lang=pug"
import script from "./FolioGraph.vue?vue&type=script&lang=js"
export * from "./FolioGraph.vue?vue&type=script&lang=js"
import style0 from "./FolioGraph.vue?vue&type=style&index=0&id=36a7ea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7ea4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
